import { Box, Flex, Text } from '@chakra-ui/react';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { ReactComponent as CloseIcon } from '../../../assets/images/icons/ic-exit.svg';
import Thumb from '../../../assets/images/thumb-ad.png';
import { PDFViewer } from '../../../components/pdfViewer';
import { usePrescriptionStore } from '../../../stores/prescriptionStore';
import { TrackerEventService } from '../../prescription/trackerEventService';
import { amplitudeModule } from '../../../shared/amplitude';

type NewsProps = {
  onClose: () => void;
};
const News = ({ onClose }: NewsProps) => {
  const [isPdfOpen, setIsPdfOpen] = useState<boolean>(false);
  const [isVideoOpen, setIsVideoOpen] = useState<boolean>(false);
  const { prescription } = usePrescriptionStore();
  const { prescriberConfiguration } = usePrescriptionStore();

  const pdfUrl = 'https://nxd-static-images.s3.sa-east-1.amazonaws.com/ad.4e697f2afa57da0a16d0.pdf';

  const onOpenPdf = async () => {
    await TrackerEventService.track(
      prescription?.idPrescricao || 0,
      'backoffice_campaign_news_library_content_clicou',
      {
        idPrescricao: prescription?.idPrescricao,
        idMedico: prescription?.idPrescritor,
        codigoValidacao: prescription?.CodigoValidacao,
        idParceiro: prescriberConfiguration?.idParceiro,
        tipoConteudo: 'lamina',
        nomeConteudo: 'Wegovy',
        timeStamp: DateTime.now(),
      }
    );

    amplitudeModule.whatsNewClicked({
      validation_code: prescription?.CodigoValidacao ?? '',
      partner_id: prescriberConfiguration?.idParceiro ?? 0,
      partner_name: prescriberConfiguration?.Nome ?? '',
      establishment_name: prescription?.Estabelecimento?.Nome ?? '',
      // hardcoded hoje pois essa tela aqui ainda não é dinamica
      // único item é esse pdf da wegovy
      item: [{
        id: 1,
        name: 'Wegovy',
        description: 'Muito além da perda de peso',
        sponsor: 'Novo Nordisk',
        type: 'lamina',
        URL: pdfUrl,
      }],
    });

    setIsPdfOpen(true);
  };

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      background="rgba(18, 4, 31, 0.94)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex="12"
    >
      {isVideoOpen ? (
        <Box
          position="fixed"
          width="80vw"
          height="80vh"
          background="rgba(18, 4, 31, 0.94)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex="12"
        >
          <Box w="100%" h="100%" background={'white'} borderRadius="8px">
            <Box w={'100%'} placeItems={'end'} mb={'16px'} pr={'10px'} pt={'10px'}>
              <CloseIcon onClick={() => setIsVideoOpen(false)} cursor={'pointer'} />
            </Box>
            <iframe
              data-testid="tutorial-iframe"
              width="100%"
              height="100%"
              src={'https://www.youtube.com/embed/FpR36s924_w'}
              title={'Video Wegovy'}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </Box>
        </Box>
      ) : null}
      {isPdfOpen ? (
        <PDFViewer title="Wegovy" fileUrl={pdfUrl} onClose={() => setIsPdfOpen(false)} />
      ) : (
        <Box
          w={{ md: '887px' }}
          h={{ md: '628px' }}
          padding={{ base: '24px 24px', md: '24px 50px' }}
          borderRadius="8px"
          boxShadow="0 4px 12px rgba(0, 0, 0, 0.2)"
          background="white"
          color="black"
          textAlign="left"
        >
          <Box w={'100%'} placeItems={'end'} mb={'16px'}>
            <CloseIcon onClick={onClose} cursor={'pointer'} />
          </Box>
          <Text fontSize={30} color={'rgba(61, 14, 107, 1)'} fontWeight={700} mb="32px">
            Conheça as novidades
          </Text>
          <Flex justifySelf={{ base: 'center', md: 'inherit' }} gap={10}>
            <Box
              padding="16px"
              borderRadius="16px"
              boxShadow="3px 3px 10px 0px rgba(61, 14, 107, 0.1)"
              cursor={'pointer'}
              onClick={onOpenPdf}
            >
              <Box w={{ base: '130px', lg: '219px' }} h={{ lg: '101' }} borderRadius={'16px'} mb={'8px'}>
                <img src={Thumb} alt="Thumb" />
              </Box>
              <Text fontSize={'14px'} color={'rgba(61, 14, 107, 1)'} fontWeight={700}>
                Wegovy
              </Text>
              <Text fontSize={'12px'} color={'#909090'} fontWeight={700}>
                Muito além da perda de peso
              </Text>
            </Box>
            {/* <Box
              padding="16px"
              borderRadius="16px"
              boxShadow="3px 3px 10px 0px rgba(61, 14, 107, 0.1)"
              cursor={'pointer'}
              onClick={openVideo}
            >
              <Box w={{ base: '130px', lg: '219px' }} h={{ lg: '101' }} borderRadius={'16px'} mb={'8px'}>
                <img src={Thumb} alt="Thumb" />
              </Box>
              <Text fontSize={'14px'} color={'rgba(61, 14, 107, 1)'} fontWeight={700}>
                Wegovy Video
              </Text>
              <Text fontSize={'12px'} color={'#909090'} fontWeight={700}>
                Muito além da perda de peso
              </Text>
            </Box> */}
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default News;
